import type { PreviewClientDeactivationDto } from '@aid/shared';

export const clientesKeys = {
  all: ['clientes'] as const,
  lists: () => [...clientesKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...clientesKeys.lists(), filters] as const,
  details: () => [...clientesKeys.all, 'detail'] as const,
  detail: (id: number) => [...clientesKeys.details(), id] as const,
  ubicacionPreview: (id: number, location: { latitud: number; longitud: number }) =>
    [...clientesKeys.all, 'ubicacion-preview', id, location] as const,
  cobros: (id: number) => [...clientesKeys.all, 'cobros', id] as const,
  eventos: (id: number) => [...clientesKeys.all, 'eventos', id] as const,
  serieMensualBase: (id: number) =>
    [...clientesKeys.all, 'estado-cuenta', 'serie-mensual', id] as const,
  estadoCuenta: (id: number, filters?: Record<string, unknown>) =>
    filters === undefined
      ? ([...clientesKeys.all, 'estado-cuenta', id] as const)
      : ([...clientesKeys.all, 'estado-cuenta', id, filters] as const),
  estadoCuentaSimple: (id: number, filters: Record<string, unknown>) =>
    [...clientesKeys.all, 'estado-cuenta-simple', id, filters] as const,
  serieMensual: (id: number, filters: Record<string, unknown>) =>
    [...clientesKeys.serieMensualBase(id), filters] as const,
  deactivation: (id: number) => [...clientesKeys.all, 'deactivation', id] as const,
  deactivationPreview: (id: number, input: PreviewClientDeactivationDto) =>
    [...clientesKeys.all, 'deactivation-preview', id, input] as const,
  cambioDiaPreview: (id: number, fechaCobro: string) =>
    [...clientesKeys.all, 'cambio-dia-preview', id, fechaCobro] as const,
};
